import firestore from "../firebase.config";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
    Card,
    CardActionArea,
    CardMedia,
    CardContent,
    Divider,
    Grid,
    Typography,
    Box,
} from "@material-ui/core";
import { Rating } from "@material-ui/lab";
import { useAuth } from "../context/AuthContext";
import "../App.css";

// fetch rec videos
// TODO: replace 10 with userId
const fetchRecVideos = async (userId) => {
    const recVideoList = await firestore
        .collection("cb_recommendation")
        .doc(userId)
        .get();

    const recIds = recVideoList.data().pred;

    const recVideos = await firestore
        .collection("videos")
        .where("videoId", "in", recIds)
        .get();

    return recVideos.docs.map((doc) => doc.data());
};


// query firestore in batches
const getContentById = async (ids, path) => {
    return new Promise((res) => {
        // don't run if there aren't any ids or a path for the collection
        if (!ids || !ids.length || !path) return res([]);

        const collectionPath = firestore.collection(path);
        let batches = [];

        while (ids.length) {
            // firestore limits batches to 10
            const batch = ids.splice(0, 10);

            // add the batch request to to a queue
            batches.push(
                new Promise((response) => {
                    collectionPath
                        .where("videoId", "in", [...batch])
                        .get()
                        .then((results) =>
                            response(
                                results.docs.map((result) => ({
                                    ...result.data(),
                                }))
                            )
                        );
                })
            );
        }

        // after all of the data is fetched, return it
        Promise.all(batches).then((content) => {
            res(content.flat());
        });
    });
};

const getRatedVideos = async (userId) => {
    // 1. Query ratings table on userId
    const ratingsRef = firestore.collection("ratings");
    const queryRat = await ratingsRef.where("userId", "==", userId).get();

    if (queryRat.empty) return;

    let ratedVideos = [];

    queryRat.forEach((doc) => {
        const data = doc.data();
        const rat = {
            videoId: data.videoId,
            userRating: data.value,
        };
        ratedVideos.push(rat);
    });

    // 2. Query videos by rated ids
    const ratedVideoIds = ratedVideos.map((v) => v.videoId);
    const queryRatedBatch = getContentById(ratedVideoIds, "videos");

    let ratedVidArray = [];

    await queryRatedBatch
        .then((querySnapshot) => {
            if (!querySnapshot.empty) {
                querySnapshot.forEach((data) => {
                    const findUserRating = ratedVideos.find(
                        ({ videoId }) => videoId === data.videoId
                    );
                    const vidObject = {
                        videoId: data.videoId,
                        videoTitle: data.title,
                        videoLink: data.youtubeId,
                        avgRating: data.avgRating,
                        userRating: findUserRating.userRating,
                    };
                    ratedVidArray.push(vidObject);
                });
            }
        })
        .catch((err) => {
            console.log(err);
        });

    return ratedVidArray;
};


function Dashboard() {
    const { currentUser } = useAuth();
    const [recVideos, setRecVideos] = useState([]);
    const [ratedVideos, setRatedVideos] = useState([]);
    const classes = useStyles();

    useEffect(() => {
        getRatedVideos(currentUser.uid).then((ratedVideos) => {
            setRatedVideos(ratedVideos);
        });
        if (currentUser) {
            fetchRecVideos(currentUser.uid).then((recVideos) => {
                setRecVideos(recVideos);
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="wrapper">
            {recVideos && currentUser && (
                <div className="category">
                    <Typography
                        variant="h4"
                        style={{ marginBottom: 20, textAlign: "left" }}
                    >
                        &micro;Lesson for{" "}
                        {currentUser.email.substring(
                            0,
                            currentUser.email.indexOf("@")
                        )}
                    </Typography>
                    <Grid container spacing={3}>
                        {recVideos.map((vid, i) => {
                            return (
                                <Grid key={i} item xs={3}>
                                    <Link
                                        key={i}
                                        to={`/playVideo/${vid.videoId}`}
                                        style={{ textDecoration: "none" }}
                                    >
                                        <Card className={classes.videocard}>
                                            <CardActionArea>
                                                <CardMedia
                                                    component="img"
                                                    height="150"
                                                    width="150"
                                                    image={`https://img.youtube.com/vi/${vid.videoId}/default.jpg`}
                                                    title={vid.title}
                                                    alt={vid.title}
                                                />
                                            </CardActionArea>
                                            <CardContent>
                                                <Typography noWrap>
                                                    {" "}
                                                    {vid.title}{" "}
                                                </Typography>
                                            </CardContent>
                                            <Box
                                                display="flex"
                                                justifyContent="flex-end"
                                                mr={2}
                                            >
                                                <Box
                                                    bgcolor="text.primary"
                                                    color="background.paper"
                                                    mb={1}
                                                    borderRadius={16}
                                                    width="50%"
                                                    height="10%"
                                                >
                                                    <Typography
                                                        noWrap
                                                        style={{
                                                            fontSize: 12,
                                                        }}
                                                    >
                                                        {vid.category}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Card>
                                    </Link>
                                </Grid>
                            );
                        })}
                    </Grid>
                </div>
            )}
            <Divider style={{ height: 3 }} />

            <div className="dashboard">
                <h1>Your Rated &micro;Lesson</h1>
                <Grid container spacing={3}>
                    {ratedVideos ? (
                        ratedVideos.map((vid, i) => {
                            return (
                                <Grid key={i} item xs={3}>
                                    <Link
                                        key={i}
                                        to={`/playVideo/${vid.videoId}`}
                                        style={{ textDecoration: "none" }}
                                    >
                                        <Card className={classes.videocard}>
                                            <CardActionArea>
                                                <CardMedia
                                                    component="img"
                                                    height="150"
                                                    width="150"
                                                    image={`https://img.youtube.com/vi/${vid.videoId}/default.jpg`}
                                                    title="test"
                                                    alt="test"
                                                />
                                            </CardActionArea>
                                            <CardContent>
                                                <Typography
                                                    variant="body"
                                                    noWrap
                                                >
                                                    <b>{vid.videoTitle}</b>
                                                </Typography>
                                                <Box m={1}>
                                                    <Typography variant="body">
                                                        Avg Rating:{" "}
                                                        {vid.avgRating.toFixed(
                                                            2
                                                        )}{" "}
                                                        / 5
                                                    </Typography>
                                                </Box>
                                                <Box m={1}>
                                                    <Typography variant="body">
                                                        Your Rating:
                                                        <Rating
                                                            value={
                                                                vid.userRating
                                                                    ? vid.userRating
                                                                    : ""
                                                            }
                                                            readOnly
                                                        />
                                                    </Typography>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Link>
                                </Grid>
                            );
                        })):(
                        <Box m={5}>
                            <Typography variant="h5" align="center">
                                Opps, No rated video yet.
                            </Typography>
                        </Box>
                        )}
                </Grid>
            </div>
        </div>
    );
}

export default Dashboard;

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    filterbar: {
        margin: theme.spacing(2),
    },
    cardhover: {
        backgroundColor: "rgba(170, 30, 60, 0.9)",
        color: "#ffffff",

        "&:hover": {
            background: "rgba(170, 30, 60, 0.5)",
            color: "#000000",
        },
    },
    videocard: {
        transition: "transform 250ms",
        "&:hover": {
            transform: "scale(1.1)",
        },
    },
}));
